'use client';
import { ChangeEvent, FC, useCallback, useState } from 'react';
import { useSettingsContext } from '@/contexts/SettingsContext';
import { TLabels } from '@/features/contentful/types/types';

interface Props {
    onOptionClick: () => void;
}

const DEFAULT_SELECTED_VALUE = 1;

const GroupSelect: FC<Props> = ({ onOptionClick }) => {
    const [selected, setSelected] = useState(DEFAULT_SELECTED_VALUE);

    const { getLabel } = useSettingsContext();
    const COLINSON_GROUP_BOARD_LABEL = getLabel('label', 'collinsonGroupBoard');
    const COLINSON_GROUP_COMPANIES_LABEL = getLabel('label', 'collinsonGroupCompanies');

    const handleChange = useCallback(
        (e: ChangeEvent<HTMLSelectElement>) => {
            setSelected(parseInt(e.target.value));
            onOptionClick();
        },
        [onOptionClick],
    );

    return (
        <div className="tw-w-full tw-relative md:tw-hidden tw-border-blue-500">
            <select
                name="groups"
                id="peopleTabMob"
                className="tw-w-full tw-h-auto tw-p-[12px] tw-font-gotham-book tw-text-[14px]
                tw-text-[#3e4247]
                tw-border tw-border-[#979797] tw-appearance-none
                tw-pr-10 !focus:tw-shadow-blue-300 focus:tw-outline-blue-200"
                value={selected}
                onChange={handleChange}
            >
                <option value={1}> {COLINSON_GROUP_BOARD_LABEL}</option>
                <option value={2}>{COLINSON_GROUP_COMPANIES_LABEL}</option>
            </select>
            <div className="tw-pointer-events-none tw-absolute tw-bottom-[53px] tw-right-0 tw-flex tw-items-center tw-px-2">
                <div className="tw-flex tw-flex-col tw-gap-0.5">
                    <div className="tw-w-0 tw-h-0 tw-border-x-4 tw-border-x-transparent tw-border-b-4 tw-border-solid tw-border-b-black"></div>
                    <div className="tw-w-0 tw-h-0 tw-border-x-4 tw-border-x-transparent tw-border-t-4 tw-border-solid tw-border-t-black"></div>
                </div>
            </div>
        </div>
    );
};

export default GroupSelect;
